"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toIcon = exports.getAutomationIntegrationDisplayName = void 0;
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_1 = __importDefault(require("react"));
var getAutomationIntegrationDisplayName = function (integrationName, automationsMetadata) {
    var integration = automationsMetadata.find(function (automationsMetadata) {
        return automationsMetadata.integrationName === integrationName;
    });
    return integration ? integration.displayName : integrationName;
};
exports.getAutomationIntegrationDisplayName = getAutomationIntegrationDisplayName;
function toIcon(iconName) {
    switch (iconName) {
        case "archive":
            return react_1.default.createElement(icons_1.Archive, null);
        case "hashtag":
            return react_1.default.createElement(icons_1.Hashtag, null);
        case "informationCircle":
            return react_1.default.createElement(icons_1.InformationCircle, null);
        case "security":
            return react_1.default.createElement(icons_1.Security, null);
        case "preview":
            return react_1.default.createElement(icons_1.Preview, null);
        case "hubspot":
            return react_1.default.createElement(icons_1.Hubspot, null);
        case "slack":
            return react_1.default.createElement(icons_1.Slack, null);
        default:
            return undefined;
    }
}
exports.toIcon = toIcon;
